import React from 'react';
import { useTranslation } from 'utils/translation';
import config from 'config/app';
import css from './test-warning.module.scss';

const TestWarning = () => {
  const { t } = useTranslation();
  const isTestEnv = config.isTestEnv;

  if (!isTestEnv) {
    return null;
  }

  return (
    <div className={css.root}>
      <div className={css.content}>{t('test_warning_label')}</div>
    </div>
  );
};

export default TestWarning;
